import React from 'react';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
export default function AsyncSpinner() {
    return React.createElement(Box, { display: "flex", justifyContent: "center" },
        React.createElement(CircularProgress, { variant: "indeterminate", size: 64 }));
}
